import { render, staticRenderFns } from "./NcrPageForm.vue?vue&type=template&id=3bfbc506&"
import script from "./NcrPageForm.vue?vue&type=script&lang=js&"
export * from "./NcrPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports